import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
} from '@angular/core';
import { Router } from '@angular/router';
import { ExpertEventNotificationRecord } from '@libs/shared/api';
import { ExpertEventNotificationWrapperComponent } from '@sprint-expert/app/modules/expert-event-notification/expert-event-notification-wrapper.component';
import { injectExpertEventNotificationService } from '@sprint-expert/app/modules/expert-event-notification/expert-event-notification.service';

@Component({
  selector: 'app-expert-member-food-card-feedback-comment-created-notification',
  standalone: true,
  imports: [CommonModule, ExpertEventNotificationWrapperComponent],
  template: `
    <app-expert-event-notification-wrapper
      class="cursor-pointer"
      (click)="onClick()"
      [notification]="notification"
      title="{{
        notification.notifier.nickname
      }}님이 식단 피드백에 댓글을 남겼어요">
      <div
        class="text-secondary line-clamp-2"
        [innerHTML]="notification.comment.description"></div>
    </app-expert-event-notification-wrapper>
  `,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpertMemberFoodCardFeedbackCommentCreatedNotificationComponent {
  readonly vm = injectExpertEventNotificationService();
  readonly router = inject(Router);

  @Input({ required: true })
  notification: ExpertEventNotificationRecord;

  onClick() {
    this.vm.readExpertEventNotification(this.notification);
    this.router.navigate(
      [
        'expert-workspace',
        this.vm.currentExpertWorkspace$$().id,
        'expert-member',
        this.notification.expertMemberFoodCardFeedback.expertMemberId,
      ],
      {
        queryParams: { tab: 'food-card' },
        onSameUrlNavigation: 'reload',
      }
    );
  }
}
